import type { Note } from "@/core/types";

// Negative check bc some notes dont have note_state and should remain selectable

export function isNoteSelectable(note: Note): boolean {
  if (!note) return false;

  return (
    note.note_state !== "draft" &&
    note.note_state !== "pending" &&
    note.note_state !== "rejected" &&
    note.note_state !== "resubmitted"
  );
}
